import { getMonthName } from "common/helpers/utils";
import type { WorkExperience } from "common/types";

export function formatMonthAndYear(data: { month: number; year: number }) {
  const { month, year } = data;
  const monthName = getMonthName(month - 1);
  if (monthName) {
    return `${monthName} ${year}`;
  }
  return year.toString();
}

export function formatRange(from: string, to: string) {
  return [from, to].filter((value) => !!value).join(" - ");
}

export function formatExperienceStartAndEnd(
  start: WorkExperience["start_date"],
  end: WorkExperience["end_date"],
) {
  return formatRange(
    start ? formatMonthAndYear(start) : "Unknown start date",
    end ? formatMonthAndYear(end) : "Present",
  );
}

export function getCompaniesFromWorkExperience(
  workExperience: WorkExperience[],
) {
  return workExperience
    ? workExperience.reduce<Record<string, WorkExperience[]>>(
        (accumulator, currentValue) => {
          const key = currentValue.company ? currentValue.company.name : "";
          if (!accumulator[key]) {
            accumulator[key] = [];
          }
          accumulator[key].push(currentValue);
          return accumulator;
        },
        {},
      )
    : {};
}
